module.exports = __webpack_public_path__ + "static/img/ruzhuBanner.d21c731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ruzhuBanner.png
// module id = hElM
// module chunks = 18